import { action, observable, toJS } from "mobx";
import { create, persist } from "mobx-persist";
import { API } from "../Network/API";
import { APIClient } from "network-stapler";
import { IZipZone } from "../Utils/Interface";

const hydrate = create({
	storage: localStorage,
	jsonify: true,
});

class ZipZonesStore {
	@observable isLoading: boolean = false;
	@persist @observable showZipInputField: boolean = false;
	@observable zones?: Array<IZipZone>;
	@persist("object") @observable selectedPartner?: IZipZone;
	@observable latestZipzoneInput: string | undefined;
	@persist @observable selectedRegion: string | undefined;
	@persist @observable zipCodeCount: number | undefined;
	apiClientDynamicBaseUrl: APIClient;

	constructor(apiClientDynamicBaseUrl: APIClient, langLocal: string) {
		this.apiClientDynamicBaseUrl = apiClientDynamicBaseUrl;

		if (this.apiClientDynamicBaseUrl) {
			this.loadZipData(langLocal);
			hydrate("zipStore", this).then(() => console.log("someStore has been hydrated", toJS(this)));
		}
	}

	async loadZipData(langLocal: string) {
		const target = API.getZipZones(langLocal);

		this.isLoading = true;
		try {
			const zones = await this.apiClientDynamicBaseUrl.requestType<Array<IZipZone>>(target);
			this.zones = zones;
			this.zones = this.sortByRegionName(this.zones);
			this.isLoading = false;
		} catch (e) {
			console.error(e);
			this.isLoading = false;
		}
	}

	sortByRegionName(zones: IZipZone[]) {
		return zones.sort((a, b) => {
			return a.regionName?.localeCompare(b.regionName || "") || -1;
		});
	}

	@action toggleZipZoneSelection(regionName: string, count: number, zipCodeCount: number) {
		// clear store
		this.selectedPartner = undefined;
		// set country selection
		this.selectedRegion = regionName;
		// set zip code count of selected region 
		this.zipCodeCount = zipCodeCount;

		if (count <= 1 || count === undefined) {
			this.showZipInputField = false;
			this.zones?.forEach((zone: IZipZone) => {
				if (zone.regionName === regionName) {
					this.selectedPartner = zone;
				}
			});
		} else {
			this.showZipInputField = true;
		}
	}

	@action toggleZipInput(input: string) {
		var foundZone = false;

		// start searching when input length is equal to zip code count, depending on country (e.g. Austria = 4/ Germany = 5)
		if (this.zipCodeCount !== undefined && input.length >= this.zipCodeCount) {
			input = input.replace(/[^0-9]/g, "");
			this.latestZipzoneInput = input

			this.zones?.forEach((zone: IZipZone) => {
				// only show zip zone outputs of selected region
				if (zone.regionName === this.selectedRegion) {
					// first check the zones (first two digest)
					if (zone.zipZones !== null) {
						var range = input.toString().match(/^(\d{2})/) || null;
						if (range !== null) {
							zone?.zipZones?.forEach((zoneNumber: string) => {
								if (range !== null && typeof range[0] !== "undefined" && range[0] === zoneNumber) {
									this.selectedPartner = zone;
									foundZone = true;
									// check the individual zips
								} else if (zone.individualZips !== null && !foundZone) {
									zone?.individualZips?.forEach((indZoneNumber: string) => {
										if (input === indZoneNumber) {
											this.selectedPartner = zone;
											foundZone = true;
										}
									});
								}
							});
						}
					}
				}
			});

			// if flag is still false, no match was found
			if (!foundZone) {
				this.zones?.forEach((zone: IZipZone) => {
					if (zone.isHeadquarter) {
						this.selectedPartner = zone;
					}
				});
				console.log("no match");
			}
		} else {
			// clear selection
			this.selectedPartner = undefined;
			foundZone = false;
		}
	}
}
// const zipZonesStore: ZipZonesStore = new ZipZonesStore();

export { ZipZonesStore };
